import axios from 'axios';
import moment from 'moment'
window.moment = moment;


export default class InstagramFeed {
  constructor() {
    this.feeds = document.querySelectorAll('[data-instagram-feed]');
  }

  init() {
    if(!this.feeds.length) {
      return false;
    }

    this.feeds.forEach((wrapper) => {
      this.getLastPost(wrapper)
    })
  }

  getLastPost(wrapper) {

    let image = wrapper.querySelector('[data-instagram-post-image]');
    let caption = wrapper.querySelector('[data-instagram-post-caption]');
    let name = wrapper.querySelector('[data-instagram-account-name]');
    let date = wrapper.querySelector('[data-instagram-post-publish-date]');

    const ajax_form_data = new FormData(this.search_form);
    ajax_form_data.append('action', 'getInstagramPost');

    axios.post(ajax_object.ajax_url, ajax_form_data)
      .then(function (response) {
        console.log(response);
        image.src = response['data']['image'];
        caption.innerText = response['data']['caption'];
        name.innerText = '@' + response['data']['name'];
        date.innerText = response['data']['ago'];

      })
      .catch(error => {
        console.log(error.response.data.error);
      })
  }
}
